import * as i0 from '@angular/core';
import { isDevMode, Injectable, Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { throwError, of } from 'rxjs';
import { catchError, shareReplay, switchMap, filter } from 'rxjs/operators';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';

class CommunityService {
    constructor(http) {
        this.http = http;
        this.baseUrl = '';
        this.TRANSLATIONS_URL = '/community/error-modal/i18n/';
        this.PHONE_URL = '/community/phone';
        this.START_CALL_EVENT = 'communications:start-call';
        if (isDevMode()) {
            this.baseUrl = 'http://dev.almundo.com.ar:5001';
        }
    }
    getTranslations(site, media) {
        const params = { media };
        return this.http
            .get(`${this.baseUrl}${this.TRANSLATIONS_URL}${site}`, { params })
            .pipe(catchError(this.handleError));
    }
    getPhoneNumber(source) {
        if (isDevMode()) {
            source = source.replace('http%3A%2F%2Flocal.almundo.com.ar%3A4200%2F', encodeURIComponent('https://dv.almundo.com.ar/'));
        }
        const url = `${this.baseUrl}${this.PHONE_URL}?source=${source}`;
        return this.http.get(url).pipe(catchError(this.handleError));
    }
    openCallCenter(document) {
        document.dispatchEvent(new CustomEvent(this.START_CALL_EVENT, {
            detail: { origin: 'experts-modal-error' }
        }));
    }
    handleError(err) {
        let errorMessage = '';
        if (err.error instanceof ErrorEvent) {
            errorMessage = `An error occurred: ${err.error.message}`;
        }
        else {
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return throwError(errorMessage);
    }
}
/** @nocollapse */ CommunityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CommunityService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ CommunityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CommunityService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CommunityService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class MediaService {
    isMobileResolution(innerWidth) {
        return innerWidth < 768;
    }
}
/** @nocollapse */ MediaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MediaService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ MediaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MediaService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MediaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class GoogleAnalyticsService {
    constructor() { }
    emitEvent(eventAction, nonInteraction = false) {
        const eventCategory = 'buyerModalError';
        const eventLabel = null;
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({
            event: 'trackEvent',
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventAction: eventAction,
            nonInteraction
        });
    }
}
/** @nocollapse */ GoogleAnalyticsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GoogleAnalyticsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ GoogleAnalyticsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GoogleAnalyticsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GoogleAnalyticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AmExpertsComponentsService {
    constructor(http) {
        this.http = http;
        this.config$ = null;
        this.config$ = this.http
            .get('/community/components-config')
            .pipe(shareReplay(1));
    }
    componentIsEnabled(componentName) {
        return this.config$.pipe(switchMap((config) => {
            return of(!!config[componentName]);
        }), catchError(err => of(false)));
    }
}
/** @nocollapse */ AmExpertsComponentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsComponentsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmExpertsComponentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsComponentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsComponentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class AmExpertsModalErrorComponent {
    constructor(communityService, mediaService, googleAnalyticsService, componentsService) {
        this.communityService = communityService;
        this.mediaService = mediaService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.componentsService = componentsService;
        this.isTranslationsLoaded = false;
        this.isPhoneNumberLoaded = false;
        this.isDesktop = !this.mediaService.isMobileResolution(window.innerWidth);
        this.media = this.isDesktop ? 'desktop' : 'mobile';
    }
    ngOnInit() {
        this.componentsService
            .componentIsEnabled('amExpertsModalError')
            .pipe(filter((enabled) => enabled))
            .subscribe(() => this.init());
    }
    init() {
        this.isArgentina = this.site === 'es-AR';
        this.googleAnalyticsService.emitEvent('impression', true);
        this.communityService
            .getTranslations(this.site, this.media)
            .subscribe(data => {
            this.translations = data.translations;
            this.isTranslationsLoaded = true;
        });
        this.communityService
            .getPhoneNumber(encodeURIComponent(window.location.href))
            .subscribe(data => {
            this.phone = data.phone;
            this.isPhoneNumberLoaded = true;
        });
    }
    openCallCenter() {
        this.googleAnalyticsService.emitEvent('clickLlamar');
        this.communityService.openCallCenter(document);
    }
    callAnalogPhone(phone) {
        this.googleAnalyticsService.emitEvent('clickTelAnalogico');
        window.location.assign(`tel:${phone}`);
    }
    trackClickSucursales() {
        this.googleAnalyticsService.emitEvent('clickSucursales');
    }
    get canRenderComponent() {
        return this.isTranslationsLoaded && this.isPhoneNumberLoaded;
    }
    get isWebRTCSupported() {
        return (navigator.getUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.msGetUserMedia);
    }
}
/** @nocollapse */ AmExpertsModalErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsModalErrorComponent, deps: [{ token: CommunityService }, { token: MediaService }, { token: GoogleAnalyticsService }, { token: AmExpertsComponentsService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AmExpertsModalErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmExpertsModalErrorComponent, selector: "am-experts-modal-error", inputs: { site: "site" }, ngImport: i0, template: "<div *ngIf=\"canRenderComponent\" class=\"am-experts-modal-error-container\">\n  <div class=\"am-experts-modal-error-header\" [innerHTML]=\"translations?.header\"></div>\n  <div class=\"am-experts-modal-error-body\">\n    <div *ngIf=\"isDesktop\">\n      <b>{{phone}}</b>\n    </div>\n  </div>\n  <div class=\"am-experts-modal-error-footer\" *ngIf=\"isArgentina\" (click)=\"trackClickSucursales()\"\n    [innerHTML]=\"translations?.footer\">\n  </div>\n</div>", styles: [".am-experts-modal-error-container{clear:both;display:flex;flex-direction:column;flex-shrink:0;font-family:ProximaNova,sans-serif;line-height:25px;text-align:center}.am-experts-modal-error-container .am-experts-modal-error-body{padding:10px 0}.am-experts-modal-error-container .am-experts-modal-error-body .button-secondary{background:transparent;border:1px solid #179ea4;border-radius:20px;color:#179ea4;cursor:pointer;font-size:15px;font-weight:700;height:40px;margin:4px 0 10px;width:160px}.am-experts-modal-error-container .am-experts-modal-error-body .button-secondary:hover{border:1px solid #0e727c;color:#0e727c}.am-experts-modal-error-container .am-experts-modal-error-footer{padding-bottom:20px}.am-experts-modal-error-container .am-experts-modal-error-footer a{color:#179ea4;font-weight:700;text-decoration:none}.am-experts-modal-error-container .am-experts-modal-error-footer a:hover{color:#0e727c}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsModalErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-experts-modal-error', encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"canRenderComponent\" class=\"am-experts-modal-error-container\">\n  <div class=\"am-experts-modal-error-header\" [innerHTML]=\"translations?.header\"></div>\n  <div class=\"am-experts-modal-error-body\">\n    <div *ngIf=\"isDesktop\">\n      <b>{{phone}}</b>\n    </div>\n  </div>\n  <div class=\"am-experts-modal-error-footer\" *ngIf=\"isArgentina\" (click)=\"trackClickSucursales()\"\n    [innerHTML]=\"translations?.footer\">\n  </div>\n</div>", styles: [".am-experts-modal-error-container{clear:both;display:flex;flex-direction:column;flex-shrink:0;font-family:ProximaNova,sans-serif;line-height:25px;text-align:center}.am-experts-modal-error-container .am-experts-modal-error-body{padding:10px 0}.am-experts-modal-error-container .am-experts-modal-error-body .button-secondary{background:transparent;border:1px solid #179ea4;border-radius:20px;color:#179ea4;cursor:pointer;font-size:15px;font-weight:700;height:40px;margin:4px 0 10px;width:160px}.am-experts-modal-error-container .am-experts-modal-error-body .button-secondary:hover{border:1px solid #0e727c;color:#0e727c}.am-experts-modal-error-container .am-experts-modal-error-footer{padding-bottom:20px}.am-experts-modal-error-container .am-experts-modal-error-footer a{color:#179ea4;font-weight:700;text-decoration:none}.am-experts-modal-error-container .am-experts-modal-error-footer a:hover{color:#0e727c}\n"] }]
        }], ctorParameters: function () { return [{ type: CommunityService }, { type: MediaService }, { type: GoogleAnalyticsService }, { type: AmExpertsComponentsService }]; }, propDecorators: { site: [{
                type: Input
            }] } });

class CoreModule {
}
/** @nocollapse */ CoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ CoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: CoreModule, imports: [HttpClientModule] });
/** @nocollapse */ CoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CoreModule, providers: [CommunityService, GoogleAnalyticsService, MediaService], imports: [HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [HttpClientModule],
                    providers: [CommunityService, GoogleAnalyticsService, MediaService]
                }]
        }] });

class AmExpertsModalErrorModule {
}
/** @nocollapse */ AmExpertsModalErrorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsModalErrorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AmExpertsModalErrorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsModalErrorModule, declarations: [AmExpertsModalErrorComponent], imports: [CoreModule, CommonModule], exports: [AmExpertsModalErrorComponent] });
/** @nocollapse */ AmExpertsModalErrorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsModalErrorModule, providers: [AmExpertsComponentsService], imports: [CoreModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsModalErrorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AmExpertsModalErrorComponent],
                    imports: [CoreModule, CommonModule],
                    exports: [AmExpertsModalErrorComponent],
                    providers: [AmExpertsComponentsService]
                }]
        }] });

/*
 * Public API Surface of am-experts-modal-error
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmExpertsModalErrorComponent, AmExpertsModalErrorModule };
